import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { LOGOS } from "@/lib/assets";

export default function Footer() {
  return (
    <footer className="bg-background border-t border-foreground/10 py-16" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between gap-10">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 font-display font-extrabold tracking-tight text-lg">
            <Compass className="w-5 h-5" strokeWidth={2.5} />
            OSMAND<span className="font-serif-editorial italic font-normal lowercase">masterclass</span>
          </div>
          <p className="text-muted-foreground mt-4 leading-relaxed">
            Il corso gratuito online di Ugo Filosa e Offroad Italia per padroneggiare OsmAnd in enduro, 4x4 e non solo.
          </p>
          <div className="flex items-center gap-6 mt-8">
            <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" aria-label="Offroad Italia" data-testid="footer-offroad-link">
              <img src={LOGOS.offroadHorizontal} alt="Offroad Italia" className="h-14 w-auto rounded transition-opacity hover:opacity-80" data-testid="footer-offroad-logo" />
            </a>
            <img src={LOGOS.osmandPin} alt="OsmAnd" className="h-14 w-auto rounded" data-testid="footer-osmand-logo" />
          </div>
          <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 text-sm text-primary hover:underline font-semibold" data-testid="footer-website-link">
            www.offroaditalia.com →
          </a>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <span className="uppercase tracking-[0.2em] text-xs text-muted-foreground mb-2">Link</span>
          <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-testid="footer-nav-website">Offroad Italia</a>
          <a href="#manifesto" className="hover:text-primary transition-colors">Il Corso</a>
          <a href="#docente" className="hover:text-primary transition-colors">Docente</a>
          <a href="#iscrizione" className="hover:text-primary transition-colors">Iscriviti</a>
          <Link to="/admin/login" className="hover:text-primary transition-colors" data-testid="footer-admin-link">Area Riservata</Link>
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mt-12 pt-8 border-t border-foreground/10 text-xs text-muted-foreground uppercase tracking-[0.15em]">
        © {new Date().getFullYear()} OsmAnd Masterclass · Offroad Italia · Corso gratuito
      </div>
    </footer>
  );
}
